import { GoogleAnalyticsConfig } from './types';

export const createGoogleAnalyticsConfig = (env: Record<string, any>): GoogleAnalyticsConfig | undefined => {
    return env['googleAnalyticsTagId'] && { tagId: env['googleAnalyticsTagId'] };
};
